//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'spec-grid-row',
  props: {
    content2: String,
    content3: String
  }
};